import React, { useState } from "react";

const UserEventsCard = ({ usersData, searchTerm = "" }) => {
  const [selectedUser, setSelectedUser] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  // Filter users based on search term
  const filteredUsers = usersData.filter(user => 
    user.id.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Get event keys for a selected user
  const getUserEventKeys = (user) => {
    if (!user) return [];
    return Object.keys(user).filter(key => key !== 'id');
  };

  // Handle user selection
  const handleUserClick = (user) => {
    setSelectedUser(user);
    setIsModalOpen(true);
  };

  // Close modal
  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="bg-gray-900 rounded-lg shadow-lg p-6 border border-gray-800">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold text-white">User Event Tracking</h2>
        <div className="bg-gray-800 px-4 py-2 rounded-md">
          <span className="text-white font-medium">Total Users: {filteredUsers.length}</span>
        </div>
      </div>
      
      <div className="mb-6">
        <div className="overflow-x-auto">
          <table className="w-full table-auto">
            <thead>
              <tr className="bg-gray-800 text-white">
                <th className="px-4 py-3 text-left">User ID</th>
                <th className="px-4 py-3 text-left">Event Count</th>
                <th className="px-4 py-3 text-left">Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredUsers.length > 0 ? (
                filteredUsers.map((user) => (
                  <tr 
                    key={user.id} 
                    className="border-b border-gray-700 hover:bg-gray-800 cursor-pointer"
                  >
                    <td className="px-4 py-3 text-white text-left">{user.id}</td>
                    <td className="px-4 py-3 text-white text-left">
                      {Object.keys(user).filter(key => key !== 'id').length}
                    </td>
                    <td className="px-4 py-3 text-white text-left">
                      <button 
                        onClick={() => handleUserClick(user)}
                        className="px-3 py-1 bg-gray-700 text-white rounded hover:bg-gray-600 transition-colors"
                      >
                        View Details
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="3" className="px-4 py-3 text-white text-center">
                    No users found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Modal */}
      {isModalOpen && selectedUser && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-gray-900 rounded-lg max-w-4xl w-full mx-4 max-h-screen overflow-y-auto">
            <div className="p-6">
              <div className="flex justify-between items-center mb-6">
                <h3 className="text-xl font-semibold text-white">
                  Event Details for User: <span className="text-blue-400">{selectedUser.id}</span>
                </h3>
                <button 
                  onClick={closeModal}
                  className="text-gray-400 hover:text-white focus:outline-none"
                >
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
                  </svg>
                </button>
              </div>
              
              <div className="overflow-x-auto">
                <table className="w-full table-auto">
                  <thead>
                    <tr className="bg-gray-800 text-white">
                      <th className="px-4 py-3 text-left">Event Name</th>
                      <th className="px-4 py-3 text-left">Clicks</th>
                      <th className="px-4 py-3 text-left">Duration Watched</th>
                      <th className="px-4 py-3 text-left">Event Details</th>
                    </tr>
                  </thead>
                  <tbody>
                    {getUserEventKeys(selectedUser).length > 0 ? (
                      getUserEventKeys(selectedUser).map((eventKey) => (
                        <tr key={eventKey} className="border-b border-gray-700 hover:bg-gray-800">
                          <td className="px-4 py-3 text-white text-left">{eventKey}</td>
                          <td className="px-4 py-3 text-white text-left">
                            {selectedUser[eventKey]?.clicks || "-"}
                          </td>
                          <td className="px-4 py-3 text-white text-left">
                            {selectedUser[eventKey]?.durationWatched || 
                             selectedUser[eventKey]?.["durationWatched"] || 
                             selectedUser[eventKey]?.["durationMatched"] || "-"}
                          </td>
                          <td className="px-4 py-3 text-white text-left">
                            {selectedUser[eventKey]?.eventDetails || "-"}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="4" className="px-4 py-3 text-white text-center">
                          No events found for this user
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              
              <div className="mt-6 flex justify-end">
                <button 
                  onClick={closeModal}
                  className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserEventsCard;